import { render, staticRenderFns } from "./OzTabsWithSeparator.vue?vue&type=template&id=4985e0ac&"
import script from "./OzTabsWithSeparator.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzTabsWithSeparator.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports